// src/pages/Dashboard/Admin/DepensesRecettesDashboard/components/AccountingActionsCard.jsx

import React from "react";
import { FaChevronDown, FaChevronUp, FaMagic, FaPlus } from "react-icons/fa";

const ACTIONS = [
  {
    key: "cotisation",
    title: "Cotisations perçues",
    tone: "emerald",
    description:
      "Crée une recette à partir des montants de cotisation des règlements au statut Réglé.",
    button: "Ajouter Cotisation",
  },
  {
    key: "licences",
    title: "Licences FFJDA",
    tone: "indigo",
    description:
      "Crée la recette Club et la dépense France Judo correspondant aux licences réglées.",
    button: "Ajouter Licences",
  },
  {
    key: "passSport",
    title: "Pass’Sport",
    tone: "amber",
    description:
      "Crée une dépense accordée aux adhérents et une recette attendue/remboursée par l’État.",
    button: "Ajouter Pass’Sport",
  },
  {
    key: "reductions",
    title: "Réductions accordées",
    tone: "rose",
    description:
      "Agrège les réductions famille et saison en une dépense de remise accordée.",
    button: "Ajouter Réductions",
  },
  {
    key: "boutique",
    title: "Chiffre d’affaires boutique",
    tone: "emerald",
    description:
      "Agrège les ventes boutique de la saison, hors acomptes, en recette club.",
    button: "Ajouter CA Boutique",
  },
];

export default function AccountingActionsCard({
  visible,
  onToggle,
  loadingStates,
  onAddCotisation,
  onAddLicences,
  onAddPassSport,
  onAddReductions,
  onAddBoutiqueCA,
  selectedSeason,
}) {
  const handlers = {
    cotisation: onAddCotisation,
    licences: onAddLicences,
    passSport: onAddPassSport,
    reductions: onAddReductions,
    boutique: onAddBoutiqueCA,
  };

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-amber-400 via-orange-500 to-rose-500" />

      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start justify-between gap-4 p-4 text-left sm:p-5 lg:p-6"
      >
        <div>
          <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
            Automatisation
          </p>

          <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
            <FaMagic className="text-amber-500" />
            Actions automatiques
          </h2>

          <p className="mt-1 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
            Génère les écritures de synthèse à partir des règlements et ventes
            boutique.
            {selectedSeason
              ? ` Saison utilisée : ${selectedSeason}.`
              : " Si aucune saison n’est sélectionnée, la saison active est utilisée."}
          </p>
        </div>

        <span className="mt-1 rounded-2xl bg-slate-100 p-3 text-slate-600 dark:bg-slate-800 dark:text-slate-200">
          {visible ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </button>

      {visible && (
        <div className="grid gap-3 border-t border-slate-200 p-4 dark:border-slate-800 sm:p-5 lg:grid-cols-5 lg:p-6">
          {ACTIONS.map((action) => (
            <ActionButton
              key={action.key}
              action={action}
              loading={Boolean(loadingStates?.[action.key])}
              onClick={handlers[action.key]}
            />
          ))}
        </div>
      )}
    </section>
  );
}

function ActionButton({ action, loading, onClick }) {
  const tones = {
    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    indigo:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    amber:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    rose:
      "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300",
  };

  return (
    <article className={`flex flex-col justify-between rounded-2xl border p-4 ${tones[action.tone]}`}>
      <div>
        <h3 className="font-bold text-slate-950 dark:text-white">
          {action.title}
        </h3>

        <p className="mt-1 text-xs leading-5 text-slate-600 dark:text-slate-300">
          {action.description}
        </p>
      </div>

      <button
        type="button"
        onClick={onClick}
        disabled={loading}
        className="mt-4 inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-3 py-2 text-xs font-bold text-slate-900 shadow-sm ring-1 ring-black/5 transition hover:bg-slate-50 disabled:cursor-wait disabled:opacity-60 dark:bg-slate-950 dark:text-white dark:ring-white/10"
      >
        <FaPlus className={loading ? "animate-spin" : ""} />
        {loading ? "Calcul..." : action.button}
      </button>
    </article>
  );
}